export default class WebhookForm {
  id: string;

  url: string;

  webhookTypeId: string;

  username: string | null;

  password: string | null;

  hasBasicAuthentication: boolean;

  constructor(obj: any = {}) {
    this.id = obj.id;
    this.url = obj.url || '';
    this.webhookTypeId = obj.webhookTypeId || null;
    this.username = obj.username || '';
    this.password = obj.password || '';
    this.hasBasicAuthentication = obj.hasBasicAuthentication;
    if (this.hasBasicAuthentication === null || this.hasBasicAuthentication === undefined) {
      this.hasBasicAuthentication = true;
    }
  }

  public formatToRequest(): WebhookForm {
    if (!this.hasBasicAuthentication) {
      this.username = null;
      this.password = null;
    }
    return this;
  }
}
